const TosContents = () => (
    <div className="section-block">
        <div className="row">
            <div className="column width-12">
                <p>현재 준비중입니다.</p>
            </div>
        </div>
    </div>
);

export default TosContents;